<template>
  <div class="select_dialog_embed">
    <div class="supplier_list_embed_msg">
      <div class="select_dialog_embed_box"
           :class="{'select_dialog_embed_box_w530': showType === 'batchSaveActivityStoreroomLinkDocking' || showType=== 'batchSaveActivityStoreroomGoodsDocking',
            'select_dialog_embed_box_w660': showType === 'getLinkDetailsById' || showType === 'getGoodsDetailsById',
            'select_dialog_embed_box_w880': showType === 'loadActivityLogPageList'}">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <div class="select_dialog_embed_box_content">
          <!--新增活动-->
          <div v-if="showType === 'addActivity'" class="select_dialog_embed_box_handle">
            <div class="dialog_addActivity">
              <span><label>*</label>店铺</span>
              <div>
                <el-select v-model="selectStore" placeholder="请选择店铺">
                  <el-option
                    v-for="item in storeList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="dialog_addActivity">
              <span><label>*</label>活动名称</span>
              <div><input type="text" title="活动名称" v-model="activityName" aria-placeholder="活动名称"></div>
            </div>
          </div>

          <!--添加链接/货号-->
          <div v-if="showType === 'addLinkOrGoods'" class="select_dialog_embed_box_handle">
            <div class="dialog_addLinkOrGoods">
              <div class="mb20">
                <label class="fcDel">*</label>
                <input type="radio" id="activityLink" name="activityType" value="0" v-model="activityType">
                <label for="activityLink">链接</label>
                <input type="radio" id="activityGoods" name="activityType" value="1" v-model="activityType">
                <label for="activityGoods">货号</label>
              </div>
              <div>
                <label class="fcDel">*</label>
                <textarea name="addActivityLinkOrGoodsMsg" v-model="activityContent" cols="45" rows="15" placeholder="换行输入可批量添加多个链接Id/货号，每次添加将追加或覆盖所选类型现有已设置数据（设置链接Id只覆盖已添加的链接数据，不会覆盖已添加的货号数据）"></textarea>
              </div>
              <p class="fcDel mt10 fs12">
                换行输入可批量添加多个链接Id/货号，每次添加将追加或覆盖所选类型现有已设置数据（设置链接Id只覆盖已添加的链接数据，不会覆盖已添加的货号数据）
              </p>
            </div>
          </div>

          <!--链接批量对接仓库-->
          <div v-if="showType === 'batchSaveActivityStoreroomLinkDocking'" class="select_dialog_embed_box_handle">

            <!--表格固定头部-->
            <table class="table tb_border">
              <colgroup>
                <col style=" width: 100%">
              </colgroup>
              <thead>
              <tr>
                <th><input type="checkbox" title="全选" v-model="checkAll"  @click="checkOneOrAll()"/></th>
                <th>仓库名称</th>
                <th>配货率(%)</th>
                <th>配仓优先级</th>
              </tr>
              </thead>
            </table>
            <!--表格滚动内容-->
            <table class="table">
              <colgroup>
                <col style="width: 100%">
              </colgroup>
              <tbody v-if="inventoryDockingList.length">
              <tr v-for="(item, index) in inventoryDockingList" :key="index">
                <td><input type="checkbox" title="选择" v-model="checkboxModel[index]"></td>
                <td>{{item.StoreroomName}}</td>
                <td>{{item.RealSendRate}}</td>
                <td><input type="text" v-model="item.SetOrderNum"></td>
              </tr>
              </tbody>
              <tbody v-if="!inventoryDockingList.length">
              <tr>
                <td colspan="10">暂时没有相关信息</td>
              </tr>
              </tbody>
            </table>
          </div>

          <!--关闭/打开库存对接-->
          <div v-if="showType === 'closeOrOpenTheInventoryConnection'" class="select_dialog_embed_box_handle text_center">
            <div class="dialog_addLinkOrGoods">
              <div class="mt40 mb40">
                <input type="radio" id="closeInventoryConnection" name="closeOpenInventoryConnection" value="0" v-model="activityType">
                <label for="closeInventoryConnection">关闭</label>
                <input type="radio" id="openInventoryConnection" name="closeOpenInventoryConnection" value="1" v-model="activityType" >
                <label for="openInventoryConnection">开启</label>
              </div>
            </div>
          </div>

          <!--按链接同步库存-->
          <div v-if="showType === 'synceLinkStock'" class="select_dialog_embed_box_handle text_center">
            <div class="dialog_addLinkOrGoods">
              <div class="mt40 mb40">
                确定同步该活动中链接的库存？
                <p>确认后后台将异步处理同步，同步进度请查看同步日志。</p>
              </div>
            </div>
          </div>

          <!--查看链接-->
          <div v-if="showType === 'getLinkDetailsById'" class="select_dialog_embed_box_handle text_center">
            <div class="dialog_addLinkOrGoods">
              <!--表格-->
              <table class="table">
                <thead>
                <tr>
                  <th>链接ID</th>
                  <th>对接状态</th>
                  <th>对接仓库</th>
                </tr>
                </thead>
                <tbody v-if="list.length">
                <tr v-for="(item, index) in list" :key="index">
                  <td>{{item.LinkIdOrGoodsId}}</td>
                  <td>{{item.StockDockStatusName}}</td>
                  <td>{{item.StoreroomNames}}</td>
                </tr>
                </tbody>
                <tbody v-if="!list.length">
                <tr>
                  <td colspan="3">暂时没有相关的数据</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--查看货号-->
          <div v-if="showType === 'getGoodsDetailsById'" class="select_dialog_embed_box_handle text_center get_goods_details_byId">
            <div class="dialog_addLinkOrGoods">
              <!--表格-->
              <table class="table">
                <thead>
                <tr>
                  <th>店铺</th>
                  <th>货号</th>
                  <th>对接仓库</th>
                </tr>
                </thead>
                <tbody v-if="list.length">
                <tr v-for="(item, index) in list" :key="index">
                  <td>{{item.ShopName}}</td>
                  <td>{{item.LinkIdOrGoodsId}}</td>
                  <td>{{item.StoreroomNames}}</td>
                </tr>
                </tbody>
                <tbody v-if="!list.length">
                <tr>
                  <td colspan="3">暂时没有相关的数据</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--货号批量对接仓库-->
          <div v-if="showType === 'batchSaveActivityStoreroomGoodsDocking'" class="select_dialog_embed_box_handle">

            <!--表格固定头部-->
            <table class="table tb_border">
              <colgroup>
                <col style=" width: 100%">
              </colgroup>
              <thead>
              <tr>
                <th><input type="checkbox" title="全选" v-model="checkAll"  @click="checkOneOrAll()"/></th>
                <th>仓库名称</th>
                <th>配货率(%)</th>
                <th>配仓优先级</th>
              </tr>
              </thead>
            </table>
            <!--表格滚动内容-->
            <table class="table">
              <colgroup>
                <col style="width: 100%">
              </colgroup>
              <tbody v-if="inventoryDockingList.length">
              <tr v-for="(item, index) in inventoryDockingList" :key="index">
                <td><input type="checkbox" title="选择" v-model="checkboxModel[index]"></td>
                <td>{{item.StoreroomName}}</td>
                <td>{{item.RealSendRate}}</td>
                <td><input type="text" v-model="item.SetOrderNum"></td>
              </tr>
              </tbody>
              <tbody v-if="!inventoryDockingList.length">
              <tr>
                <td colspan="10">暂时没有相关信息</td>
              </tr>
              </tbody>
            </table>
          </div>

          <!--查看同步日志-->
          <div v-if="showType === 'loadActivityLogPageList'" class="select_dialog_embed_box_handle text_center">
            <div class="load_activity_logPage_list">
              <div class="load_activity_logPage_list_shop">
                <el-select v-model="activitySyncStatus" placeholder="请选择店铺">
                  <el-option
                    v-for="item in activitySyncStatusList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <button class="btn_normal mr20" @click="loadActivityLogPageList()">查询</button>
              <button class="btn_normal" @click="isResync = true">库存未成功数据重新同步</button>
              <!--表格-->
              <table class="table">
                <thead>
                <tr>
                  <th>链接ID</th>
                  <th>库存状态</th>
                  <th>库存处理时间</th>
                  <th>内容</th>
                </tr>
                </thead>
                <tbody v-if="list.length">
                <tr v-for="(item, index) in list" :key="index">
                  <td>{{item.LinkIdOrGoodsId}}</td>
                  <td>{{item.StockAsyncStatusName}}</td>
                  <td>{{item.StockAsyncTime | time}}</td>
                  <td>{{item.AsyncResult}}</td>
                </tr>
                </tbody>
                <tbody v-if="!list.length">
                <tr>
                  <td colspan="8">暂时没有相关的数据</td>
                </tr>
                </tbody>
              </table>

              <div v-if="isResync" class="resync">
                <div>
                  <p>确认对未成功数据重新同步吗？</p>

                  <button class="btn_normal mr50" @click="reSyncFailLinkDetail()">确定</button>
                  <button class="btn_cancel" @click="isResync = false">取消</button>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom">
          <button v-if="showType === 'addLinkOrGoods'" class="btn_normal" @click="saveActivityDetail(1)">追加</button>
          <button v-if="showType === 'addLinkOrGoods'" class="btn_del" @click="saveActivityDetail(2)">覆盖</button>

          <button v-if="showType !== 'addLinkOrGoods' && showType !== 'getLinkDetailsById' && showType !== 'loadActivityLogPageList'" class="btn_normal" @click="submitBtn()">确定</button>
          <button class="btn_cancel" @click="cancelBtn(showType, isSuc)">关闭</button>
        </div>
      </div>

      <!--信息提示框-->
      <msg-dialog v-if="isMsg"
                  :is-suc="isSuc"
                  :txt="txtMsg" @closebtn="closeMsgDialog"></msg-dialog>
    </div>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
  </div>
</template>

<script>
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: "activity-link-embed",
    /**
     *  title：  头部名
     *  showType: sAnnounceDetail=供应商公告信息
     *  msg: 互传的信息
     * */
    props: ['title', 'showType', 'msg'],
    components: {MsgDialog, LoadingDialog},
    watch: {
      'checkboxModel': function (val) {
        let flag = true;
        val.forEach((value) => {
          if (!value) {
            flag = false;
            return flag;
          }
        });
        this.checkAll = flag;
        if (!this.checkboxModel.length) {
          this.checkAll = false;
        }
      } // 单选
    },
    directives: {
      // 监听input是否是正整数
      positiveInt: {
        bind: function(el) {
          el.handler = function() {
            el.value = Number(el.value.replace(/\D+/, ''))
            // el.value = Number(el.value.replace(/^[0-9]*[1-9][0-9]*$/, ''))
          }
          el.addEventListener('input', el.handler)
        },
        unbind: function(el) {
          el.removeEventListener('input', el.handler)
        }
      }
    },
    data() {
      return {
        list: [], // 列表数据
        checkAll: false, // 全选
        checkboxModel: [], // checkbox框值
        storeList: [], // 店铺
        selectStore: '', // 选择的店铺
        activityName: null, // 活动名称
        activityType: 0, // 链接类型，0=链接，1=货号
        activityContent: null, // 添加链接/货号的内容
        inventoryDockingList: [], // 设置库存对接的列表
        activitySyncStatusList: [
          {id: null, text: '请选择状态'},
          {id: 0, text: '未触发'},
          {id: 1, text: '待处理'},
          {id: 2, text: '同步成功'},
          {id: 3, text: '同步失败'}
        ], // 活动同步状态枚举值
        activitySyncStatus: null, // 活动同步状态选择值
        isResync: false, // 库存未成功数据重新同步
        isLoading: false, // 加载页面
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '暂时没有相关的数据', // 信息框内容
        errorTxt: '', // 错误提示
        isShowMsgDialog: false, // 是否显示信息提示框
        time: 3, // 倒计时时间
        timer: null // 计时器
      }
    },
    methods: {
      // 单选/全选
      checkOneOrAll() {
        for (let i = 0; i < this.checkboxModel.length; i++) {
          this.checkboxModel[i] = !this.checkAll;
        }
      },

      // 获取店铺下拉框信息
      getAllPXShopList() {
        this.$axios.get(this.Global.getAllPXShopList).then((res) => {
          if (!res.data.errorMsg) {
            if (res.data.resData.length) {
              this.storeList = res.data.resData;
              this.selectStore = res.data.resData[0].Id;
            } else {
              this.storeList = res.data.resData;
              this.selectStore = '';
            }
          } else {
            this.storeList = [];
            this.selectStore = res.data.errorMsg;
          }
        });
      },

      // 新增活动
      saveActivity() {
        if (!this.selectStore) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择一个店铺';
          return;
        }
        if (!this.activityName) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请填写活动名称';
          return;
        }
        this.isLoading = true;
        const params = {
          ActivityId: 0,
          ShopId: this.selectStore,
          ActivityName: this.activityName.trim()
        };
        this.$axios.post(this.Global.saveActivity, params).then((res) => {
          if (res.data.errorMsg.length) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
            this.isLoading = false;
          } else {
            this.isMsg = true;
            this.isSuc = true;
            this.txtMsg = '操作成功！';
            // this.$emit('cancelbtn', {isShow: false, issuc: this.isSuc, showType: this.showType});
          }
        });
      },

      // 添加链接/货号
      saveActivityDetail(addType) {
        if (!this.activityContent) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请填写链接/货号';
          return;
        }
        const listContent = this.activityContent.split('\n');
        this.isLoading = true;
        const params = {
          ActivityId: this.msg,
          ActivityType: this.activityType,
          Atype: addType, // addType添加的类型：1=追加，2=覆盖
          idList: listContent
        };
        this.$axios.post(this.Global.saveActivityDetail, params).then((res) => {
          if (res.data.errorMsg.length) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
            this.isLoading = false;
          } else {
            this.isMsg = true;
            this.isSuc = true;
            this.txtMsg = '操作成功！';
          }
        });
      },

      // 获取分销商的渠道信息（ 店铺货品列表、店铺链接列表 批量设置渠道对接适用 ）——获取批量操作的渠道信息入口
      getStoreroomListByShopId() {
        this.$axios.post(this.Global.getStoreroomListByShopId(this.msg.ShopId), null).then((res) => {
          if (!res.data.errorMsg.length) {
            this.inventoryDockingList = res.data.resData;
            this.checkboxModel = Array(this.inventoryDockingList.length).fill(false);
          }
        });
      },

      // 链接批量对接仓库
      batchSaveActivityStoreroomLinkDocking() {
        let checkboxModelLst = []; // 选择的skuId
        let listIndex = []; // 记住选择到的列表数据下标
        this.checkboxModel.findIndex((val, i) => {
          if (val === true) {
            checkboxModelLst.push({
              storeroomId: this.inventoryDockingList[i].StoreroomId,
              setOrderNum: this.inventoryDockingList[i].SetOrderNum
            });
          }
        });
        /*if (!checkboxModelLst.length) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择要批量操作的仓库';
          return;
        }*/

        const params = {
          ActivityId: this.msg.ActivityId,
         /* storeroomOrderNumList: [
            {
              storeroomId: "string",
              setOrderNum: 0
            }
          ]*/
          storeroomOrderNumList: checkboxModelLst
        };
        this.$axios.post(this.Global.batchSaveActivityStoreroomLinkDocking, params).then((res) => {
          if (res.data.errorMsg.length) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
            this.isLoading = false;
          } else {
            this.isMsg = true;
            this.isSuc = true;
            this.txtMsg = '操作成功！';
          }
        });
      },

      // 开启活动对应的货号或链接的库存对接
      openActivityStockDocking() {
        this.$axios.post(this.Global.openActivityStockDocking(this.msg.ActivityId), null).then((res) => {
          if (res.data.errorMsg.length) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
            this.isLoading = false;
          } else {
            this.isMsg = true;
            this.isSuc = true;
            this.txtMsg = '操作成功！';
          }
        });
      },

      // 关闭活动对应的货号或链接的库存对接
      closeActivityStockDocking() {
        this.$axios.post(this.Global.closeActivityStockDocking(this.msg.ActivityId), null).then((res) => {
          if (res.data.errorMsg.length) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
            this.isLoading = false;
          } else {
            this.isMsg = true;
            this.isSuc = true;
            this.txtMsg = '操作成功！';
          }
        });
      },

      // 按链接同步库存
      synceLinkStock() {
        this.$axios.post(this.Global.synceLinkStock(this.msg.ActivityId), null).then((res) => {
          if (res.data.errorMsg.length) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
            this.isLoading = false;
          } else {
            this.isMsg = true;
            this.isSuc = true;
            this.txtMsg = '操作成功！';
          }
        });
      },

      // 查看链接
      getLinkDetailsById() {
        this.$axios.post(this.Global.getLinkDetailsById(this.msg.ActivityId), null).then((res) => {
          console.log(res.data.resData);
          if (!res.data.errorMsg.length) {
            this.list = res.data.resData;
          } else {
            this.list = [];
          }
        });
      },

      // 查看货号
      getGoodsDetailsById(){
        this.$axios.post(this.Global.getGoodsDetailsById(this.msg.ActivityId), null).then((res) => {
          console.log(res.data.resData);
          if (!res.data.errorMsg.length) {
            this.list = res.data.resData;
          } else {
            this.list = [];
          }
        });
      },

      // 货号批量对接仓库
      batchSaveActivityStoreroomGoodsDocking() {
        let checkboxModelLst = []; // 选择的skuId
        let listIndex = []; // 记住选择到的列表数据下标
        this.checkboxModel.findIndex((val, i) => {
          if (val === true) {
            checkboxModelLst.push({
              storeroomId: this.inventoryDockingList[i].StoreroomId,
              setOrderNum: this.inventoryDockingList[i].SetOrderNum
            });
          }
        });
        /*if (!checkboxModelLst.length) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择要批量操作的仓库';
          return;
        }*/

        const params = {
          ActivityId: this.msg.ActivityId,
          storeroomOrderNumList: checkboxModelLst
        };
        this.$axios.post(this.Global.batchSaveActivityStoreroomGoodsDocking, params).then((res) => {
          if (res.data.errorMsg.length) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
            this.isLoading = false;
          } else {
            this.isMsg = true;
            this.isSuc = true;
            this.txtMsg = '操作成功！';
          }
        });
      },

      // 查看同步日志数据
      loadActivityLogPageList() {
        const params = {
          ActivityId: this.msg.ActivityId,
          StockStatus: this.activitySyncStatus
        };
        this.$axios.post(this.Global.loadActivityLogPageList, params).then((res) => {
          console.log(res.data.resData);
          if (!res.data.errorMsg.length) {
            this.list = res.data.resData.DataList;
          } else {
            this.list = [];
          }
        });
      },

      // 重新同步未成功数据
      reSyncFailLinkDetail() {
        this.$axios.post(this.Global.reSyncFailLinkDetail(this.msg.ActivityId), null).then((res) => {
          this.isMsg=true;
          if (res.data.errorMsg) {
            this.isSuc=false;
            this.txtMsg = res.data.errorMsg;
          } else {
            this.isSuc=true;
            this.txtMsg = '操作成功';
          }
        });
      },

      // 提交按钮
      submitBtn() {
        if (this.showType === 'addActivity') {
          this.saveActivity();
        } else if (this.showType === 'batchSaveActivityStoreroomLinkDocking') {
          this.batchSaveActivityStoreroomLinkDocking();
        } else if (this.showType === 'closeOrOpenTheInventoryConnection') {
          if (this.activityType === 0) {
            this.closeActivityStockDocking();
          } else {
            this.openActivityStockDocking();
          }
        } else if (this.showType === 'synceLinkStock') {
          this.synceLinkStock();
        } else if (this.showType === 'batchSaveActivityStoreroomGoodsDocking') {
          this.batchSaveActivityStoreroomGoodsDocking();
        }
      },

      // 取消按钮
      cancelBtn(showType, issuc) {
        this.$emit('cancelbtn', {isShow: false, issuc: this.isSuc, showType: this.showType});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
        if (this.isSuc && this.showType !== 'duBidPublish') {
          this.cancelBtn(true);
        }
        if (this.isSuc && this.isCancelPrice) {
          this.isCancelPrice = false;
        }
      }
    },
    created() {
      if (this.showType === 'addActivity') {
        this.getAllPXShopList();
      } else if (this.showType === 'batchSaveActivityStoreroomLinkDocking' || this.showType === 'batchSaveActivityStoreroomGoodsDocking') {
        this.getStoreroomListByShopId();
      } else if (this.showType === 'getLinkDetailsById') {
        this.getLinkDetailsById();
      } else if (this.showType === 'getGoodsDetailsById') {
        this.getGoodsDetailsById();
      } else if (this.showType === 'loadActivityLogPageList') {
        this.loadActivityLogPageList();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .select_dialog_embed {
    .supplier_list_embed_msg {
      .select_dialog_embed_box {
        &.select_dialog_embed_box_w530 {
          width: 530px;

          .select_dialog_embed_box_handle {
            width: 90%;
          }

          table {
            &:nth-child(1) {
              display: block;
              padding-right: 15px;
              border-top: 1px solid #eeeeee;

              th {
                border-top: none;
                border-bottom: none;

                &:last-child {
                  border-right: none;
                }
              }
            }

            &:nth-child(2) {
              th, td {
                border: 1px solid #eee;
              }
              input[type='text'] {
                width: calc(100% - 50px);
              }
            }

            thead, tbody tr {
              display: table;
              width: 100%;
              table-layout: fixed;
            }

            tbody {
              display: block;
              width: 100%;
              height: 290px;
              overflow-y: auto;
              overflow-x: hidden;
            }

            th:first-child, td:first-child {
              width: 20px;
            }
          }
        }

        &.select_dialog_embed_box_w660{
          width: 660px;

          table {
            &:nth-child(2) {
              th, td {
                border: 1px solid #eee;
              }
              input[type='text'] {
                width: calc(100% - 50px);
              }
            }

            thead, tbody tr {
              display: table;
              width: 100%;
              table-layout: fixed;
            }

            tbody {
              display: block;
              width: 100%;
              height: 290px;
              overflow-y: auto;
              overflow-x: hidden;
            }

            th, td {
              border: 1px solid #eeeeee;
            }

            th:first-child, td:first-child {
              width: 103px;
              align-content: center;
            }

            th:nth-child(2), td:nth-child(2) {
              width: 40px;
              align-content: center;
            }
          }

          .get_goods_details_byId {

            th:nth-child(2), td:nth-child(2) {
              width: 75px;
            }
          }
        }

        &.select_dialog_embed_box_w880{
          width: 880px;
          position: relative;

          .load_activity_logPage_list_shop {
            display: inline-block;
            margin-right: 20px;
            margin-bottom: 20px;
          }

          table {
            thead, tbody tr {
              display: table;
              width: 100%;
              table-layout: fixed;
            }

            tbody {
              display: block;
              width: 100%;
              height: 290px;
              overflow-y: auto;
              overflow-x: hidden;
            }

            th, td {
              border: 1px solid #eeeeee;
            }

            td {
              word-break: break-word;
              align-content: center;
            }

            th:first-child, td:first-child {
              width: 103px;
            }

            th:nth-child(2), td:nth-child(2) {
              width: 56px;
            }

            th:nth-child(3), td:nth-child(3) {
              width: 90px;
            }
          }

          .resync {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.3);
            display: flex;
            align-items: center;
            justify-content: center;

            & > div {
              background-color: #ffffff;
              padding: 60px 80px;

              p {
                margin-bottom: 30px;
              }
            }
          }
        }

        .select_dialog_embed_box_content {
          .select_dialog_embed_box_handle {
            .dialog_addActivity {
              & > div {
                display: inline-block;
                width: 200px;

                input[type='text'] {
                  width: 85%;
                  padding: 0 14px;
                }
              }

              span {
                display: inline-block;
                width: 108px;
                text-align: right;
                margin-right: 10px;
              }

              label {
                color: red;
                width: 10px;
                text-align: right;
              }
            }

            .dialog_addLinkOrGoods {
              label {
                text-align: left;

                &:first-child {
                  width: 10px;
                  float: left;
                }
              }


            }
          }
        }

        .select_dialog_embed_box_bottom {
          .btn_del {
            padding: 7px 30px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/activity-link-embed.vue